module.exports = __webpack_public_path__ + "static/digital-periodic-maintenance-sm-7006bca988db7bef6c7c4176f49738e0.webp";